import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

const STEP_MS = 200;
export enum States { Offline, Unknown, Online }
@Component({
  selector: 'app-ampel',
  templateUrl: './ampel.component.html',
  styleUrls: ['./ampel.component.css']
})
export class AmpelComponent implements OnChanges {
  @Input() triggerAlive: object;
  public state: States = States.Offline;
  private firstRun = true;
  private seconds: number;
  private secondsTimeout;
  secondsPercent: number;
  color: string;

  public getStateText = (state: States) => States[state];
  public isStateOffline = (state: States) => state === States.Offline;


  ngOnChanges(changes: SimpleChanges): void { // called when triggerAlive changes
    if (this.firstRun) { this.firstRun = false; return; }
    this.seconds = 0;
    this.state = States.Online;
    clearInterval(this.secondsTimeout);
    this.secondsTimeout = setInterval(() => {
      this.seconds += STEP_MS / 1000;
      if (this.seconds >= 9) { this.state = States.Unknown; }
      if (this.seconds >= 15) { this.state = States.Offline; clearInterval(this.secondsTimeout); }
      this.secondsPercent = Math.min(100, 100 - (this.seconds - 1) * 100 / 15);
      this.color = (this.state === States.Online) ? 'primary' : 'accent';
    }, STEP_MS);
  }

}
